module.exports = __webpack_public_path__ + "static/img/he3.d5c6cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he3.png
// module id = jKFk
// module chunks = 1